/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020  
 */
const loginRequest = () => {
    return {
        username:'',
        telefono:null,
        password: null,
        grant_type: 'password',
        client_id: process.env.VUE_APP_OAUTH20_CLIENT_ID,
    }

}

export default loginRequest;